import { useFetch, useProcessedList } from '../../hooks';
import { splitCamelCase, splitSnakeCase } from '../../utilities';
import { getCampaignMonitoring, getCampaignMetrics } from '../../api';
import type { CampaignMonitoringItemType } from '../../api';
import type { GetCampaignMonitoringFilters } from '../../api';

export type ItemType = CampaignMonitoringItemType & {
  latest_contact_state_enum: string | null;
};

export const useCampaignMonitoring = () => {
  const result = useProcessedList<ItemType, GetCampaignMonitoringFilters>(
    async params => {
      const content = await getCampaignMonitoring(params?.filters || {});

      return {
        content: content.map(item => ({
          ...item,
          next_task_channel: splitCamelCase(item.next_task_channel),
          latest_contact_state_enum: item.latest_contact_state,
          latest_contact_state: splitSnakeCase(item.latest_contact_state, {
            capitalize: true,
          }),
        })),
      };
    },
    {
      initialFilters: { campaignId: '', latest_contact_state_enum: undefined },
      withLocalSort: true,
      withQueryParams: true,
      searchFilterKey: 'search',
      filterKeys: ['latest_contact_state_enum'],
      searchKeys: [
        'campaign_name',
        'contact_email',
        'contact_name',
        'contact_phone',
        'next_task_channel',
      ],
    }
  );

  const { data: metrics } = useFetch(
    () => getCampaignMetrics(result.filters || {}),
    [result.filters]
  );

  return { ...result, metrics };
};
